import { Card } from "react-bootstrap";
import { BadgeDomain } from "../../../../_components/Abstractions/BadgeDomain";

export const ContractorWastesCard = ({ title, wastes }) => {
  if (!wastes || wastes?.length === 0) {
    return;
  }

  return (
    <>
      <Card border="light">
        <Card.Header as="h5">{title}</Card.Header>
        <Card.Body>
          {wastes.map(x => <BadgeDomain key={x.wasteId} bg={!x.isDeleted ? "primary" : "danger"} size="smaller">{x.wasteCode} - {x.internalName}</BadgeDomain>)}
        </Card.Body>
      </Card>
    </>
  );
};

